export const flattenNav = (nav, searchValue, parentPath = '') => {
  const possibilities = searchValue.trim().toLowerCase().split(/\s+/);
  return nav.reduce((newArray, current) => {
    const currentFound = [];
    const currentName = current.name.trim().toLowerCase();
    const found = possibilities.filter(possibility => currentName.indexOf(possibility) > -1).length > 0;
    if (found) {
      currentFound.push({
        name: current.name,
        path: `${parentPath}${current.path}`,
        isChild: parentPath !== '',
      });
    }
    if (current.navChildren) {
      return [...newArray, ...currentFound, ...flattenNav(current.navChildren, searchValue, current.path)];
    }
    return currentFound.length > 0
      ? [...newArray, ...currentFound]
      : newArray;
  }, []);
}
